// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2cI7h","modalForm":"UpgradeEpcsModal_modalForm__2oHX1","modalFooter":"UpgradeEpcsModal_modalFooter__2O7Hs"};